import type { ReactNode } from 'react';
import { getGoogleMapsAddressUrl } from 'utils/shared/location/getGoogleMapsAddressUrl';
import Directions from 'svg/Directions';
import Location from 'svg/Location';
import { ButtonLinkText } from 'components/Button';
import classNames from 'styles/utils/classNames';

/** Card chrome only exists from `lg` up; below that the content sits straight on the sheet. */
export default function PreviewCard({ children }: { children: ReactNode }) {
  return (
    <div className="flex w-full flex-col gap-ds-lg lg:rounded-3xl lg:border lg:border-color-border-card-lightmode lg:bg-color-bg-lightmode-primary lg:p-[0.9375rem] lg:shadow-fab dark:lg:border-color-border-card-darkmode dark:lg:bg-color-bg-darkmode-primary">
      {children}
    </div>
  );
}

export function PreviewMedia({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div
      className={classNames(
        'relative aspect-[343/180] w-full shrink-0 overflow-hidden rounded-lg bg-color-bg-lightmode-secondary dark:bg-color-bg-darkmode-secondary lg:aspect-auto lg:rounded-xl',
        className,
      )}
    >
      {children}
    </div>
  );
}

export function PreviewLocationRow({ address }: { address: string }) {
  return (
    <div className="flex items-start gap-ds-xl lg:gap-ds-md">
      <div className="flex min-w-0 flex-1 items-start gap-ds-xs lg:gap-ds-sm">
        <Location className="mt-px h-4 w-4 shrink-0 text-color-text-lightmode-icon dark:text-color-text-darkmode-icon" />
        <span className="typography-product-caption text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
          {address}
        </span>
      </div>
      <ButtonLinkText
        size="md"
        isExternal
        href={getGoogleMapsAddressUrl(address)}
        className="flex shrink-0 items-center gap-ds-xs text-color-text-lightmode-primary dark:text-color-text-darkmode-primary"
      >
        <Directions className="h-4 w-4" />
        Directions
      </ButtonLinkText>
    </div>
  );
}
